<template>
  <div v-if="collection" class="form-container">
    <el-form ref="form" :model="collection" label-width="150px">
      <el-form-item label="作品名稱">
        <div class="text-content">
          <span>{{ collection.name ? collection.name.text_cht : '' }}</span>
        </div>
      </el-form-item>
      <el-form-item label="作者">
        <div class="text-content">
          <span>{{ getArtistNames }}</span>
        </div>
      </el-form-item>
      <el-form-item label="作品創作年代">
        <el-row class="text-flex-content">
          <div class="text-content">
            <span>{{ collection.created ? collection.created.start : '' }}</span>
          </div>
          <span class="divider"> - </span>
          <div class="text-content">
            <span>{{ collection.created ? collection.created.end : '' }}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="尺寸">
        <el-row class="text-flex-content">
          <div class="text-content">
            <span>長：{{ collection.size ? collection.size.length : '' }}</span>
          </div>
          <span class="divider"> / </span>
          <div class="text-content">
            <span>寬：{{ collection.size ? collection.size.width : '' }}</span>
          </div>
          <span class="divider"> / </span>
          <div class="text-content">
            <span>高：{{ collection.size ? collection.size.depth : '' }}</span>
          </div>
          <span class="divider"> / </span>
          <div class="text-content">
            <span>數量：{{ collection.size ? collection.size.quantity : '' }}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="媒材">
        <div class="text-content">
          <span>{{ collection.medium ? collection.medium.text_cht : '' }}</span>
        </div>
      </el-form-item>
      <el-form-item label="使用展間">
        <span></span>
      </el-form-item>
      <el-form-item label="封面圖片">
        <div class="image-content detail-image demo-image__error">
          <div class="block">
            <el-image :src="getImageUrl(collection)" fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="語音導覽">
        <el-button plain disabled>{{ collection.audio_guide && collection.audio_guide.length > 0 ? collection.audio_guide : '無檔案' }}</el-button>
      </el-form-item>
      <el-form-item label="簡介">
        <div class="text-content">
          <span>{{ collection.general_information.brief ? collection.general_information.brief.text_cht : '' }}</span>
        </div>
      </el-form-item>
      <el-form-item label="更多內容">
        <el-row v-for="(detail, index) in collection.general_information.detail" :key="index">
          <div class="detail-type-text" v-if="detail.type === 'subtitle' || detail.type === 'text'">
            <span>{{ detail.value.text_cht }}</span>
          </div>
          <div class="detail-type-image" v-if="detail.type === 'image'">
            <img :src="detail.value">
          </div>
          <div class="detail-type-video" v-if="detail.type === 'video'">
            <el-button type="text">{{ detail.value }}</el-button>
          </div>
          <div class="detail-type-hyperlink" v-if="detail.type === 'hyperlink'">
            <span class="anchor">{{ detail.value.anchor.text_cht }}</span>
            <el-button type="text">{{ detail.value.url }}</el-button>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button plain @click="goBack">返回至上一層</el-button>
        <el-button plain @click="reuse">重建這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import collectionJSON from '../../transData/collections'
import { fetchArtistList } from "../../api/artist";
import { getGCPFileUrl } from "../../api/attachment";

export default {
  name: "CollectionEdit",
  data() {
    return {
      isOlder: this.$route.params.version === 'v1',
      currentLang: 'ZH_TW',
      langList: this.$store.getters.langList,
      collection: undefined,
      collectionId: this.$route.params.collectionId,
      artistList: []
    }
  },
  computed: {
    getArtistNames: function () {
      if (this.artistList.length > 0) {
        const artistNameArray = [];
        for (const i in this.artistList) {
          artistNameArray.push(this.artistList[i]['artistLangs'][0]['name'])
        }
        return artistNameArray.join(', ')
      } else {
        return ''
      }
    }
  },
  methods: {
    getImageUrl(data) {
      if (data['general_information'] &&
        data['general_information']['coverphoto'] &&
        data['general_information']['coverphoto']['value']) {
        const imagePath = 'images' + data['general_information']['coverphoto']['value'] + '/0.jpg';
        return getGCPFileUrl(imagePath)
      } else {
        return ''
      }
    },
    extend(obj, src) {
      Object.keys(src).forEach(function(key) { obj[key] = src[key]; });
      return obj;
    },
    getCollectionData() {
      const filterCollection = collectionJSON.filter(x => x['_id'] === this.collectionId);
      this.collection = filterCollection[0];
      if (this.collection['artists'] && this.collection['artists'].length > 0) {
        const filter = {
          where: {
            or: []
          },
          include: [{
            relation: 'artistLangs',
            scope: {
              where: {
                language_key: 'ZH_TW'
              }
            }
          }]
        };
        for (const i in this.collection['artists']) {
          filter.where.or.push({
            artist_id: this.collection['artists'][i]
          })
        }
        fetchArtistList(filter).then(response => {
          this.artistList = response.data;
        }).catch(err => {
        })
      }
    },
    goBack() {
      this.$router.back(-1)
    },
    reuse() {

    }
  },
  mounted() {
    this.getCollectionData()
  }
}
</script>

<style lang="scss">
  .text-content {
    width: 100%;
    /*height: 70px;*/
    padding: 0 20px;
    background-color: white;
    /*margin: 10px 0;*/
    span {
      font-size: 14px;
      line-height: 40px;
      color: #222;
    }
  }
  .collection-image {
    width: 400px;
    height: 400px;
    background: darkgrey;
  }
  .text-flex-content {
    display: flex;
    .divider {
      padding: 0 10px;
    }
    .text-content {
      width: 150px;
    }
  }
  .detail-type-text {
    width: 100%;
    /*height: 70px;*/
    padding: 10px 20px;
    background-color: white;
    margin: 10px 0;
    span {
      font-size: 18px;
      line-height: 50px;
      color: #222;
      font-weight: bolder;
    }
  }
  .detail-type-image {
    width: 100%;
    height: 165px;
    padding: 10px 20px;
    background-color: white;
    margin: 10px 0;
    img {
      width: 195px;
      height: 145px;
      margin: auto;
      background-color: #999;
    }
  }
  .detail-type-video {
    width: 100%;
    /*height: 70px;*/
    padding: 10px 20px;
    background-color: white;
    margin: 10px 0;
  }
  .detail-type-hyperlink {
    width: 100%;
    /*height: 70px;*/
    padding: 10px 20px;
    background-color: white;
    margin: 10px 0;
    .anchor {
      display: block;
      font-size: 18px;
      line-height: 30px;
      color: #222;
      font-weight: bolder;
    }
  }
</style>
